import React from 'react';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
import ManageListingsHeader from './ManageListingsHeader';
import ListCard from './ListCard';
import styled from 'styled-components';
import ScrollTrigger from 'react-scroll-trigger';

export default class ManageListings extends React.Component {
  state = {
    selectedLayout: 'large',
    selectedSort: null,
    selectedFilter: null,
  };
  layoutChanged = selectedLayout => {
    this.setState({
      selectedLayout,
    });
  };
  sortChanged = selectedSort => {
    this.props.updateOrderBy(selectedSort);
  };
  publishChanged = selectedFilter => {
    this.props.updatePublishFilter(selectedFilter);
  };

  scrollToBottom = () => {
    const { loadMore, currentPage, totalPages } = this.props;
    if (currentPage < totalPages) {
      loadMore();
    }
  };

  render() {
    const { listings, loadMore, currentPage, totalPages, loading } = this.props;
    const { selectedLayout } = this.state;

    return (
      <Flex flex={1} width="100%" flexDirection="column" alignItems="stretch">
        <ManageListingsHeader
          layoutChanged={this.layoutChanged}
          publishChanged={this.publishChanged}
          sortChanged={this.sortChanged}
        />

        <LargeCardContainer selectedLayout={selectedLayout}>
          {listings &&
            listings.map(l => (
              <ListCard
                key={l.id}
                listing={l}
                layoutStyle={selectedLayout}
                removeListing={this.props.removeListing}
              />
            ))}
          <ScrollTrigger onEnter={this.scrollToBottom} />
          {loading && (
            <div className="f f-cc">
              <i className="fal fa-spinner" />
            </div>
          )}
        </LargeCardContainer>
      </Flex>
    );
  }
}

const LargeCardContainer = styled.div`
  display: grid;
  grid-template-columns: ${p => buildTemplateColumns(p.selectedLayout)};

  grid-gap: 22px;

  > div {
    margin-right: 12px;
    margin-left: 12px;
    margin-bottom: 24px;
  }
`;

function buildTemplateColumns(selectedLayout) {
  const width =
    selectedLayout === 'list'
      ? '100%'
      : selectedLayout === 'large'
      ? '510px'
      : '353px';
  const gridsize = 'repeat(auto-fit, minmax(' + width + ', 1fr))';
  console.log('gridsize', gridsize);
  return gridsize;
}



// WEBPACK FOOTER //
// ./src/components_new/managelisting/ManageListings.js